module.exports = __webpack_public_path__ + "static/media/filters.685bfb57.svg";